import $ from 'jquery';
import confirm from '../../../../Services/confirm';
import widgetFactory from '../../../widgetFactory';

const widgetName = 'deleteExercise';
const baseClassname = 'js-delete-exercise';

export default widgetFactory(widgetName, {
  options: {
    confirmMessage: null,
    confirmCallback: $.noop,
  },

  _create() {
    this._super(baseClassname);

    $('.js-delete-button', this.element).on('click', () => {
      this._handleDelete();
    });
  },

  _handleDelete() {
    const { confirmMessage, confirmCallback } = this.options;
    confirm.show({
      message: confirmMessage,
      cancelButton: true,
      focusButton: 'cancel',
      confirmCallback: () => {
        confirmCallback();
      },
    });
  },
});

export { baseClassname as className };
